import {
  collection, doc, getDocs, addDoc, updateDoc, deleteDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from './firebase';
import { Document } from '../types';
import { logAuditEvent } from './auditService';

export async function getDocuments(): Promise<Document[]> {
  const snap = await getDocs(collection(db, 'documents'));
  const docs = snap.docs.map(d => {
    const data = d.data();
    return {
      id: d.id,
      title: data.title,
      description: data.description,
      url: data.url,
      createdAt: data.createdAt?.toDate?.() ?? new Date(),
    };
  });
  return docs.sort((a, b) => a.title.localeCompare(b.title));
}

export async function createDocument(title: string, url: string, description?: string): Promise<string> {
  const ref = await addDoc(collection(db, 'documents'), {
    title,
    url,
    description: description ?? '',
    createdAt: serverTimestamp(),
  });
  logAuditEvent({ entityType: 'document', entityId: ref.id, action: 'create', details: title }).catch(() => {});
  return ref.id;
}

export async function updateDocument(id: string, title: string, url: string, description?: string): Promise<void> {
  await updateDoc(doc(db, 'documents', id), {
    title,
    url,
    description: description ?? '',
  });
  logAuditEvent({ entityType: 'document', entityId: id, action: 'edit', details: title }).catch(() => {});
}

export async function deleteDocument(id: string): Promise<void> {
  await deleteDoc(doc(db, 'documents', id));
  logAuditEvent({ entityType: 'document', entityId: id, action: 'delete' }).catch(() => {});
}
